import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SdkDataService } from './services/data.service';
import { SdkQuestionService } from './services/question.service';
import { SdkService } from './services/sdk.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    SdkDataService,
    SdkQuestionService,
    SdkService
  ]
})
export class SdkModule {}
